export default __webpack_public_path__ + "static/media/fightingCSS.81acec01.PNG";